<script lang="ts">
    import type {
        AccessoryButton,
        DefaultAccessory,
        SortAccessory,
        RefreshAccessory,
    } from '@jet-app/music-classical/models/section/AccessoryButton';
    import ClickAction from '~/components/jet/action/ClickAction.svelte';
    import SortButton from '~/components/jet/buttons/AccessoryButton/SortButton.svelte';
    import ClearRecentlySearched from './ClearRecentlySearched.svelte';

    export let button: AccessoryButton;

    function isClearRecentlySearchesAccessory(
        button: AccessoryButton,
    ): button is DefaultAccessory {
        return button.item?.id === 'clearButton';
    }

    function isDefaultAccessory(
        button: AccessoryButton,
    ): button is DefaultAccessory {
        return button.kind === 'default';
    }

    function isSortAccessory(button: AccessoryButton): button is SortAccessory {
        return button.kind === 'contextMenu';
    }
</script>

<div class="accessory-button" data-testid="accessory-button">
    {#if isClearRecentlySearchesAccessory(button)}
        <ClearRecentlySearched item={button.item} />
    {:else if isDefaultAccessory(button)}
        <ClickAction action={button.item.segue}>
            {button.item.text}
        </ClickAction>
    {:else if isSortAccessory(button)}
        <SortButton config={button.item} />
    {/if}
</div>

<style lang="scss">
    .accessory-button {
        --linkColor: var(--keyColor);
        display: inline-block;
        z-index: calc(var(--z-default) + 1);
        font: var(--title-3);
    }
</style>
